import { render } from "./invoice-prod.vue?vue&type=template&id=0610f702&scoped=true"
import script from "./invoice-prod.vue?vue&type=script&lang=js"
export * from "./invoice-prod.vue?vue&type=script&lang=js"

import "./invoice-prod.vue?vue&type=style&index=0&id=0610f702&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0610f702"]])

export default __exports__